(() => {
  const swiperContainer = document.querySelector(".js-media-gallery__swiper");

  const enableSwiper = () => {
    new Swiper(swiperContainer, {
      slidesPerView: 3,
      spaceBetween: 4,
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 8,
          direction: "vertical",
          autoHeight: false,
        },
      },
    });
  };

  const swapAttributes = (elem1, elem2, attributes) => {
    attributes.forEach((attr) => {
      const temp = elem1.getAttribute(attr);
      elem1.setAttribute(attr, elem2.getAttribute(attr));
      elem2.setAttribute(attr, temp);
    });
  };

  const swapFeaturedImage = (e) => {
    const target = e.target.closest(".swiper-slide img");
    if (!target) return;

    const featuredImage = document.querySelector(
      ".js-media-gallery__featured-image"
    );
    swapAttributes(featuredImage, target, ["src", "alt", "srcset"]);
  };

  const init = () => {
    enableSwiper();
    swiperContainer.addEventListener("click", swapFeaturedImage);
  };

  init();
})();
